import { html } from 'lit';
const SocketPanel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9 1.25a.75.75 0 0 1 .75.75v4.905h3.94V2a.75.75 0 0 1 1.5 0v4.905H19a.75.75 0 0 1 0 1.5h-1v5.88c0 1.5-1.215 2.715-2.714 2.715H12.58v.835a2.643 2.643 0 0 0 2.643 2.643h1.132a.75.75 0 0 1 0 1.5h-1.132a4.143 4.143 0 0 1-4.143-4.143V17H7.715A2.714 2.714 0 0 1 5 14.286v-5.88H4a.75.75 0 1 1 0-1.5h4.25V2A.75.75 0 0 1 9 1.25" clip-rule="evenodd"/>
  </svg>
`;
export default SocketPanel;
